export default __webpack_public_path__ + "media/svgs/edit-c4cfcd44.svg";